import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/youtube': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M549.7 124.1c11.4 42.9 11.4 132.3 11.4 132.3s0 89.4-11.4 132.3c-6.3 23.6-24.8 41.5-48.3 47.8-42.6 11.5-213.4 11.5-213.4 11.5s-170.8 0-213.4-11.5c-23.5-6.3-42-24.2-48.3-47.8-11.4-42.9-11.4-132.3-11.4-132.3s0-89.4 11.4-132.3c6.3-23.7 24.8-42.3 48.3-48.6 42.6-11.5 213.4-11.5 213.4-11.5s170.8 0 213.4 11.5c23.5 6.3 42 24.9 48.3 48.6zM232.1 337.6l142.7-81.2-142.7-81.2v162.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/youtube.js
// module id = 1117
// module chunks = 0